import { useEffect, useState } from 'react';
import Location from '../../hooks/Location';
import { useFirestoreID, useFirestoreQuery } from '../../firebase/useFirestore';
import parseTimestampParam from '../../helpers/questionnaire/parseTimestampParam';
import ResearchResultsPageHeader from '../../components/measurementPlan/ResearchResultsPageHeader.jsx';
import ResearchResultsQuestionList from '../../components/measurementPlan/ResearchResultsQuestionList.jsx';

/**
 * Eén ingevuld formulier: elke vraag met een resultaatkaart per vraagtype.
 *
 * Het laatste URL-segment is een `FormID` voor moderne inzendingen; oudere
 * links dragen in plaats daarvan de geserialiseerde tijdstempel van de
 * inzending ("seconden-nanoseconden").
 */
const ResearchResultsForms = () => {
    // State
    const [researchTitle, setResearchTitle] = useState('');
    const [questionnaireId, setQuestionnaireId] = useState('');

    // Hooks
    const researchId = Location()[3];
    const formParam = Location()[4];

    // Oude links dragen een tijdstempel, nieuwe een FormID.
    const isLegacyTimestampParam = /^\d+-\d+$/.test(formParam || '');
    const legacyTimestamp = isLegacyTimestampParam ? parseTimestampParam(formParam) : null;
    // '' betekent "nog geen waarde": de query wordt dan overgeslagen.
    // AI-CONTEXT: See docs/pitfalls.md#database-firestore-null-is-a-valid-query-value
    const match = isLegacyTimestampParam
        ? [['Timestamp', legacyTimestamp || '']]
        : [['FormID', formParam || '']];

    // Firestore
    const research = useFirestoreID('Research', researchId ? researchId : '');
    // Alle antwoorden van deze inzending — voedt datum, meetmoment en telling in de kop.
    const formResponses = useFirestoreQuery('QuestionnairesResponses', {
        where: [
            ['ResearchID', '==', researchId || ''],
            ...match.map(([key, value]) => [key, '==', value]),
        ],
    });

    // Zet de onderzoekstitel + de vragenlijst.
    useEffect(() => {
        research && research.forEach((item) => {
            setResearchTitle(item.Title);
            setQuestionnaireId(item.QuestionnaireID);
        });
    }, [research]);

    return (
        <div className="main">
            <div className="main-container">
                <ResearchResultsPageHeader heading={researchTitle} responses={formResponses} />
                <ResearchResultsQuestionList
                    questionnaireId={questionnaireId}
                    researchId={researchId}
                    match={match}
                />
            </div>
        </div>
    );
};

export default ResearchResultsForms;
